import { render } from "./App.vue?vue&type=template&id=6fd5515a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6fd5515a&lang=scss"

import exportComponent from "/codebuild/output/src882003474/src/vote-screen-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__